<template>
	<div class="ad-cnt">
		<el-image :src="data.image" fit="cover" class="ad-bg"></el-image>
		<div class="ad-bg container ad-center">
			<h3 class="ad-title">{{data.title}}</h3>
			<p class="ad-desc">{{data.desc}}</p>
			<div class="ad-btn">在线咨询</div>
		</div>

	</div>
</template>

<script>
	export default {
		props: {
			data: Object
		},
		data() {
			return {}
		}
	}
</script>

<style scoped lang="scss">
	@media (max-width: 767px) {
		.ad-cnt {
			height: 200px;
		}
	}

	@media (min-width: 767px) {
		.ad-cnt {
			height: 300px;
		}
	}

	@media (min-width: 992px) {
		.ad-cnt {
			height: 400px;
		}
	}

	.ad-cnt {
		position: relative;
	}

	.ad-bg {
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
	}

	.ad-center {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.ad-title {
		font-size: calc(1em + 1vw);
		line-height: calc(2.2em + 1vw);
		font-weight: bold;
		color: #FFFFFF;
	}

	.ad-desc {
		font-size: calc(0.7em + 0.5vw);
		line-height: calc(1.2em + 0.5vw);
		font-weight: 400;
		color: #FFFFFF;
	}

	.ad-btn {
		// height: 40px;
		margin-top: 20px;
		background: linear-gradient(180deg, #FFD218 0%, #FFA817 100%);
		border-radius: 20px;
		color: #9A4102;
		padding: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 4px 12px 4px 12px;
		font-size: calc(0.7em + 0.5vw);
	}
</style>
